<!--
 * @Author: your name
 * @Date: 2020-09-16 11:51:02
 * @LastEditTime: 2020-11-16 11:19:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \auxh5ui\onlineH5\privacy_notice\src\App.vue
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  *{margin: 0;padding: 0;border: 0;outline: none;-webkit-tap-highlight-color: transparent;-webkit-appearance: none;word-break: break-all;}
  ol, ul{list-style: none;}
  em, i{font-style: normal;}
  a{text-decoration: none;}
  a:focus {outline: 0;}
  button, input, select, textarea {font: inherit;margin: 0;}
  html{font-family: 'PingFangSC-Regular','Source Code Pro',sans-serif,arial;height: 100%;}
  html,body {width: 100%;min-height: 100%;max-width: 750PX;margin: 0 auto;color: rgba(69,68,74,1);}
  body {background-color: #f5f5f5;}
  #app {min-height: 100%;}
  p {
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue